'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Separator } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const DropdownDivider = forwardRef(({ className, ...props }, ref) => (_jsx(Separator, { ref: ref, className: cn('my-1 h-px bg-metal-100 dark:bg-metal-700', className), ...props })));
DropdownDivider.displayName = 'DropdownDivider';
export { DropdownDivider };
